// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Patients_Content_Content_Sections_ActiveTab_Images_Content($patient_id: numeric!, $deleted: Boolean_comparison_exp!) {
  image_series: vaxiom_patient_imageseries(
    where: { patient_id: { _eq: $patient_id }, deleted: $deleted }
    order_by: { series_date: desc }
  ) {
    id
    _id
    series_date
    name
    deleted
    scans {
      id
    }
  }
}

`